module.exports = __webpack_public_path__ + "static/img/index_banner2.414f3cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_banner2.png
// module id = JjqZ
// module chunks = 14